import React from 'react'

import Header from '../Header'
import DisplayPlaceOrder from './DisplayPlaceOrder';
import './PlaceOrder.css';


const PlaceOrder = () => {
    return (
        <React.Fragment>
            <Header />
            <DisplayPlaceOrder />

        </React.Fragment>
    )
}

export default PlaceOrder